import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=1cd1dd7c&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd1dd7c')) {
      api.createRecord('1cd1dd7c', component.options)
    } else {
      api.reload('1cd1dd7c', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=1cd1dd7c&", function () {
      api.rerender('1cd1dd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/goods.vue"
export default component.exports